/**
 * Public Share Selectors
 *
 * Atomic selectors for the public share-viewer mode.
 *
 * @module store/selectors/publicShareSelectors
 */

import type { GeoMarkupStore } from '../index';

/** True when the store serves a public share page (`/share`, `/embed`). */
export const selectIsPublicShareMode = (state: GeoMarkupStore): boolean =>
  state.publicShare.token !== null;

/** Token of the currently viewed public share, null outside public mode. */
export const selectPublicShareToken = (state: GeoMarkupStore): string | null =>
  state.publicShare.token;

/** Capability: true when the viewer has no write access (derived 1:1 from public-share mode today). */
export const selectIsReadOnlyViewer = (state: GeoMarkupStore): boolean =>
  selectIsPublicShareMode(state);
